import { Component, createRef } from 'react';

class AdSenseAd160x600 extends Component {
  constructor(props) {
    super(props);
    this.adRef = createRef();
  }

  componentDidMount() {
    try {
      if (window.adsbygoogle && this.adRef.current) {
        window.adsbygoogle.push({});
      }
    } catch (e) {
      console.error('AdSense error:', e);
    }
  }

  render() {
    return (
      <ins
        className="adsbygoogle"
        style={{ display: 'inline-block', width: '160px', height: '600px' }}
        data-ad-client="ca-pub-0193275510308560"
        data-ad-slot="9725600728"
      />
    );
  }
}

export default AdSenseAd160x600;


